export default __webpack_public_path__ + "static/media/closet3-768w.a4889d4b.avif";